import actions from '../action/category'
import CONSTANT from '../constant/category'

const categoryChildren = {
  categoryInfo: {
    categoryId: '',
    name: ''
  },
  childList: []
}
const categoryProducts = {
  page: {
    total: 0
  },
  list: []
}

const categoryBannerList = []
const categoryOptions = []
const optionProducts = {
  page: {
    total: 0
  },
  list: []
}
const selectedCategoryOption = []

const categorySelectOptionsV2 = {}
const saveCategorySelectOptionsV2 = {}
const saveCategorySelectCondition = {}

export default {
  actions,
  state: {
    categoryChildren,
    categoryProducts,
    categoryBannerList,
    categoryOptions,
    optionProducts,
    selectedCategoryOption,
    categorySelectOptionsV2,
    saveCategorySelectOptionsV2,
    saveCategorySelectCondition
  },
  mutations: {
    cleanProductsList(state) {
      return state.categoryProducts = {
        page: {
          total: 0
        },
        list: []
      }
    },
    [CONSTANT.CATEGORY_GET_CHILDREN_SUCCESS] (state, result) {
      return state.categoryChildren = result
    },
    [CONSTANT.CATEGORY_GET_CHILDREN_ERROR] (state, e) {
      return state.categoryChildren = { categoryInfo: {categoryId:'', name: ''}, childList: []}
    },
    [CONSTANT.CATEGORY_GET_PRODUCTS_SUCCESS] (state, result) {
      return state.categoryProducts = result
    },
    [CONSTANT.CATEGORY_GET_PRODUCTS_ERROR] (state, e) {
      return state.categoryProducts = { page:{total: 0}, list: []}
    },
    [CONSTANT.CATEGORY_GET_PRODUCTS_MORE_SUCCESS] (state, result) {
      return state.categoryProducts = {...result, ...{list: [...state.categoryProducts.list, ...result.list]}}
    },
    [CONSTANT.CATEGORY_GET_PRODUCTS_MORE_ERROR] (state, e) {
      // return state.categoryProducts = { page:{total: 0}, list: []}
    },
    [CONSTANT.CATEGORY_GET_BANNER_SUCCESS] (state, result) {
      return state.categoryBannerList = result
    },
    [CONSTANT.CATEGORY_GET_BANNER_ERROR] (state, e) {
      return state.categoryBannerList = []
    },
    [CONSTANT.CATEGORY_GETCATEGORYRECOMMEND_SUCCESS] (state, data) {

    },
    [CONSTANT.CATEGORY_GETCATEGORYRECOMMEND_ERROR] (state, e) {

    },
    [CONSTANT.CATEGORY_GET_OPTIONS_SUCCESS] (state, data) {
      return state.categoryOptions = data
    },
    [CONSTANT.CATEGORY_GET_OPTIONS_ERROR] (state, data) {
      return state.categoryOptions = []
    },
    [CONSTANT.CATEGORY_GET_OPTION_PRODUCTS_SUCCESS] (state, data) {
      return state.optionProducts = data
    },
    [CONSTANT.CATEGORY_GET_OPTION_PRODUCTS_ERROR] (state, e) {
      return state.optionProducts = {page: { total: 0 }, list: []}
    },
    [CONSTANT.CATEGORY_GET_OPTION_PRODUCTS_MORE_SUCCESS] (state, data) {
      return state.optionProducts = {...data, ...{list: [...state.optionProducts.list, ...data.list]}}
    },
    [CONSTANT.CATEGORY_SET_SELECTED_OPTIONS] (state, data) {
      return state.selectedCategoryOption = data
    },
    [CONSTANT.CATEGORY_CLEAN_SELECTED_OPTIONS] (state, data) {
      return state.selectedCategoryOption = []
    },
    // 筛选栏请求
    [CONSTANT.CATEGORY_GET_FILTER_OPTIONS_SUCCESS] (state, data) {
      return state.categorySelectOptionsV2 = data
    },
    [CONSTANT.CATEGORY_GET_FILTER_OPTIONS_ERROR] (state, data) {
      return state.categorySelectOptionsV2 = {}
    },
    // 筛选栏 vuex
    [CONSTANT.CATEGORY_SENT_SELECTED_OPTIONS](state, data){
      
    },
    [CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_SUCCESS](state, result){
      // return state.categoryProducts =  {...result, ...{list: [...state.categoryProducts.list, ...result.list]}}
      return state.categoryProducts = result
    },
    [CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_ERROR](state, data){
      return state.categoryProducts = []
    },
    [CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_MORER_SUCCESS](state, data){
      return state.categoryProducts = {...data, ...{list: [...state.categoryProducts.list, ...data.list]}}
    },
    [CONSTANT.CATEGORY_SUBMIT_FILTER_OPTIONS_MORE_ERROR](state, data){
      return state.categoryProducts = []
    },
    // 暂存筛选条件
    [CONSTANT.CATEGORY_SAVE_FILTER_OPTIONS](state, data){
      return state.saveCategorySelectOptionsV2 = data
    },
    [CONSTANT.CATEGORY_CLEAR_FILTER_OPTIONS](state, data){
      return state.saveCategorySelectOptionsV2 = {}
    },
    // 暂存表单数据
    [CONSTANT.CATEGORY_SAVE_FILTER_OPTIONS_CONDITION](state, data){
      return state.saveCategorySelectCondition = data
    },
    [CONSTANT.CATEGORY_CLEAR_FILTER_OPTIONS_CONDITION](state){
      return state.saveCategorySelectCondition = {}
    }
  }
}
